export class Brand {
    static SUDDEN_LINK = "Suddenlink";
    static OPTIMUM = "Optimum";
}
